<template>
    <div class="whatsapp-comparison">
        <div class="comparison-header">
            <h2 class="title">WhatsApp Çözümleri Karşılaştırması</h2>
            <div class="search-container">
                <a-input-search
                    v-model="searchQuery"
                    placeholder="Özellik ara..."
                    style="max-width: 300px"
                    @input="filterFeatures"
                />
            </div>
        </div>

        <div class="table-wrapper">
            <div class="table-header-fixed">
                <table class="comparison-table">
                    <thead>
                        <tr>
                            <th class="feature-column">Özellik</th>
                            <th class="solution-column">
                                <div class="solution-header">
                                    <div class="img whatsapp">
                                        <WhatsappV2 style="width: 24px; height: 24px" />
                                    </div>
                                    <div class="solution-info">
                                        <span>WhatsApp V2</span>
                                        <span class="solution-subtitle">(QR Code - Unofficial Solution)</span>
                                    </div>
                                </div>
                            </th>
                            <th class="solution-column">
                                <div class="solution-header">
                                    <div class="img whatsapp">
                                        <WhatsappV3Icon style="width: 24px; height: 24px" />
                                    </div>
                                    <div class="solution-info">
                                        <span>WhatsApp V3</span>
                                        <span class="solution-subtitle">(QR Code - Unofficial Solution)</span>
                                    </div>
                                </div>
                            </th>
                            <th class="solution-column">
                                <div class="solution-header">
                                    <div class="img whatsapp">
                                        <WhatsappBusinessIcon style="width: 24px; height: 24px" />
                                    </div>
                                    <div class="solution-info">
                                        <span>WhatsApp Business API</span>
                                        <span class="solution-subtitle">(WABA - Official Solution)</span>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="table-body-scrollable">
                <table class="comparison-table">
                    <colgroup>
                        <col class="feature-column-width">
                        <col class="solution-column-width">
                        <col class="solution-column-width">
                        <col class="solution-column-width">
                    </colgroup>
                    <tbody>
                        <template v-for="category in filteredCategories">
                            <tr :key="'header-' + category.name" class="category-header">
                                <td colspan="4">
                                    <div class="category-title">
                                        <span class="material-icons">{{ category.icon }}</span>
                                        {{ category.name }}
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-for="feature in category.features"
                                :key="category.name + '-' + feature.name"
                                class="feature-row"
                            >
                                <td class="feature-name">
                                    <span>{{ feature.name }}</span>
                                    <a-tooltip v-if="feature.description" :title="feature.description">
                                        <span class="material-icons info-icon">info</span>
                                    </a-tooltip>
                                </td>
                                <td class="support-cell">
                                    <div class="support-status" :class="getSupportClass(feature.v2)">
                                        <span class="material-icons support-icon">{{ getSupportIcon(feature.v2) }}</span>
                                    </div>
                                    <div v-if="feature.v2_note" class="support-note">{{ feature.v2_note }}</div>
                                </td>
                                <td class="support-cell">
                                    <div class="support-status" :class="getSupportClass(feature.v3)">
                                        <span class="material-icons support-icon">{{ getSupportIcon(feature.v3) }}</span>
                                    </div>
                                    <div v-if="feature.v3_note" class="support-note">{{ feature.v3_note }}</div>
                                </td>
                                <td class="support-cell">
                                    <div class="support-status" :class="getSupportClass(feature.waba)">
                                        <span class="material-icons support-icon">{{ getSupportIcon(feature.waba) }}</span>
                                    </div>
                                    <div v-if="feature.waba_note" class="support-note">{{ feature.waba_note }}</div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="comparison-legend">
            <div class="legend-item">
                <span class="material-icons supported">check_circle</span>
                <span>Destekleniyor</span>
            </div>
            <div class="legend-item">
                <span class="material-icons partial">help</span>
                <span>Kısmi Destek</span>
            </div>
            <div class="legend-item">
                <span class="material-icons not-supported">cancel</span>
                <span>Desteklenmiyor</span>
            </div>
        </div>
    </div>
</template>

<script>
import WhatsappV2 from "../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import WhatsappV3Icon from "../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";
import WhatsappBusinessIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";

export default {
    name: "WhatsappComparison",
    components: {
        WhatsappV2,
        WhatsappV3Icon,
        WhatsappBusinessIcon,
    },
    data() {
        return {
            searchQuery: "",
            categories: [
                {
                    name: "Temel Mesajlaşma",
                    icon: "message",
                    features: [
                        {
                            name: "Metin Mesajı Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Metin Mesajı Gönderme",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Resim Gönderme",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Resim Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Dosya Gönderme",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Dosya Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Video Gönderme",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Video Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Ses Mesajı Gönderme",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Ses Mesajı Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                    ],
                },
                {
                    name: "Özel Mesaj Türleri",
                    icon: "star",
                    features: [
                        {
                            name: "Profil Video Notu Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Profil Video Notu Alma",
                            v2: "not_supported",
                            v3: "partial_supported",
                            v3_note: "JSON mesajı olarak gözükür, LLM'ler anlayabilir",
                            waba: "not_supported",
                        },
                        {
                            name: "Anket & Oylama Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Anket & Oylama Alma",
                            v2: "not_supported",
                            v3: "partial_supported",
                            v3_note: "JSON mesajı olarak gözükür, LLM'ler anlayabilir",
                            waba: "not_supported",
                        },
                        {
                            name: "Oylama Cevabı Alma",
                            v2: "not_supported",
                            v3: "partial_supported",
                            v3_note: "JSON mesajı olarak gözükür, LLM'ler anlayabilir",
                            waba: "not_supported",
                        },
                        {
                            name: "Etkinlik Mesajı Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Etkinlik Mesajı Alma",
                            v2: "not_supported",
                            v3: "partial_supported",
                            v3_note: "JSON mesajı olarak gözükür, LLM'ler anlayabilir",
                            waba: "not_supported",
                        },
                        {
                            name: "Etkinlik Katılım Cevapları",
                            v2: "not_supported",
                            v3: "partial_supported",
                            v3_note: "JSON mesajı olarak gözükür, LLM'ler anlayabilir",
                            waba: "not_supported",
                        },
                        {
                            name: "Ürün Kataloğu Sepet Onayı",
                            v2: "not_supported",
                            v3: "partial_supported",
                            v3_note: "JSON mesajı olarak gözükür, LLM'ler anlayabilir",
                            waba: "not_supported",
                        },
                    ],
                },
                {
                    name: "Konum & İletişim",
                    icon: "location_on",
                    features: [
                        {
                            name: "Konum Mesajı Gönderme",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Konum Mesajı Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Canlı Konum Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Canlı Konum Alma",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "VCard Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "VCard Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Çoklu VCard Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Çoklu VCard Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "not_supported",
                        },
                    ],
                },
                {
                    name: "Medya & Eğlence",
                    icon: "photo_library",
                    features: [
                        {
                            name: "Sticker Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Sticker Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "GIF Gönderme",
                            v2: "supported",
                            v2_note: "Karşı tarafa video gibi gözükebilir",
                            v3: "supported",
                            v3_note: "Karşı tarafa video gibi gözükebilir",
                            waba: "supported",
                            waba_note: "Karşı tarafa video gibi gözükebilir",
                        },
                        {
                            name: "GIF Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                    ],
                },
                {
                    name: "Grup & Toplu Mesajlaşma",
                    icon: "group",
                    features: [
                        {
                            name: "Toplu Mesaj Gönderimi",
                            v2: "not_supported",
                            v2_note: "Banlanma riski var",
                            v3: "not_supported",
                            v3_note: "Banlanma riski var",
                            waba: "supported",
                        },
                        {
                            name: "Grup Mesajları Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "not_supported",
                            waba_note: "WABA'lar gruplara eklenemez",
                        },
                        {
                            name: "Gruplara Mesaj Gönderme",
                            v2: "supported",
                            v2_note: "Banlanma riski var",
                            v3: "supported",
                            v3_note: "Banlanma riski var",
                            waba: "not_supported",
                        },
                        {
                            name: "Newsletter Kanalları",
                            v2: "not_supported",
                            v3: "supported",
                            waba: "not_supported",
                            waba_note: "WABA'lar newsletter kanallarına abone olamaz",
                        },
                    ],
                },
                {
                    name: "Reklam & Pazarlama",
                    icon: "campaign",
                    features: [
                        {
                            name: "CTWA Reklam Etkileşimi (Temel)",
                            v2: "supported",
                            v2_note: "Reklam başlığı ve URL'si gelir",
                            v3: "supported",
                            waba: "supported",
                            waba_note: "Full detaylı bilgi (reklam, reklam seti, kampanya)",
                        },
                        {
                            name: "CTWA Reklam Etkileşimi (Detaylı)",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "supported",
                            waba_note: "Full detaylı bilgi (reklam, reklam seti, kampanya)",
                        },
                    ],
                },
                {
                    name: "Kullanıcı Deneyimi",
                    icon: "person",
                    features: [
                        {
                            name: "Yazıyor İndikatörü Gönderme",
                            v2: "supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Birden Çok Cihaz Desteği",
                            v2: "supported",
                            v3: "supported",
                            waba: "not_supported",
                            waba_note: "WABA'lar sadece yazılımsal olarak yönetilir",
                        },
                        {
                            name: "Otomasyondan Mesaj Gönderme",
                            v2: "partial_supported",
                            v2_note: "Banlanma riski var",
                            v3: "partial_supported",
                            v3_note: "Banlanma riski var",
                            waba: "supported",
                        },
                        {
                            name: "REST API ile Mesaj Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "supported",
                        },
                        {
                            name: "Profil Bilgilerini Düzenleme",
                            v2: "not_supported",
                            v2_note: "Sadece cihazdan yapılabilir",
                            v3: "not_supported",
                            waba: "supported",
                        },
                        {
                            name: "Mesaj Gönderenin Adı",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Profil Fotoğrafını Alma",
                            v2: "not_supported",
                            v3: "supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Chat Başlatma",
                            v2: "supported",
                            v2_note:"Herhangi bir numaraya direkt chat başlatma yapılabilir",
                            v3: "supported",
                            v3_note: "Herhangi bir numaraya direkt chat başlatma yapılabilir",
                            waba: "partial_supported",
                            waba_note: "Metanın WABA kuralları çerçevesinde şablon mesajlar ile chat başlatılabilir",
                        },
                        {
                            name: "Mesaj Ücreti",
                            v2: "not_supported",
                            v2_note:"Gelen giden mesajlardan herhangi bir ücret alınmaz",
                            v3: "supported",
                            v3_note: "Gelen giden mesajlardan herhangi bir ücret alınmaz",
                            waba: "partial_supported",
                            waba_note: "Mesajlar ücretlendirilir. https://wabapricing.supsis.ai adresinden detaylı bilgi alınabilir",
                        },
                    ],
                },
                {
                    name: "Güvenilirlik & Performans",
                    icon: "security",
                    features: [
                        {
                            name: "Stabilite & Yüksek Erişilebilirlik",
                            description: "Sistem kararlılığı ve sürekli erişilebilirlik",
                            v2: "not_supported",
                            v2_note:
                                "Sürekli QR okutma gerekebilir, bağlantılar stabil değil, mesaj senkronizasyonu bozulabilir, hesap banlanabilir. Düşük SLA için uygun.",
                            v3: "not_supported",
                            v3_note:
                                "Sürekli QR okutma gerekebilir, bağlantılar stabil değil, mesaj senkronizasyonu bozulabilir, hesap banlanabilir. Düşük SLA için uygun.",
                            waba: "supported",
                            waba_note:
                                "Resmi çözüm, %99.9 SLA, Meta kuralları çerçevesinde banlanma riski yok, bağlantı kopma sorunu olmaz, yüksek stabilite sağlar.",
                        },
                    ],
                },
                {
                    name: "Mesaj Yönetimi",
                    icon: "edit",
                    features: [
                        {
                            name: "Mesaj Reaksiyonu Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Reaksiyonu Alma",
                            v2: "not_supported",
                            v3: "supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Silme (Kendi Tarafınız)",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Silme Bilgisi (Müşteri)",
                            v2: "not_supported",
                            v3: "supported",
                            v3_note: "Supsis mesajı silmez fakat silindiği bilgisini gösterir",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Düzenleme (Kendi Tarafınız)",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Düzenleme Bilgisi (Müşteri)",
                            v2: "not_supported",
                            v3: "supported",
                            v3_note: "Düzenlendiği bilgisi Supsis'te görülür",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Caption Desteği",
                            v2: "partial_supported",
                            v3: "partial_supported",
                            waba: "not_supported",
                        },
                        {
                            name: "Mesaj Alıntılama (Gönderme)",
                            v2: "not_supported",
                            v3: "supported",
                            waba: "partial_supported",
                        },
                        {
                            name: "Mesaj Alıntılama (Alma)",
                            v2: "not_supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Tek Görünümlük Mesaj Alma",
                            v2: "supported",
                            v3: "supported",
                            waba: "supported",
                        },
                        {
                            name: "Tek Görünümlük Mesaj Gönderme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                        },
                    ],
                },
                {
                    name: "Arama & Sesli İletişim",
                    icon: "phone",
                    features: [
                        {
                            name: "WhatsApp Arama Desteği",
                            v2: "not_supported",
                            v2_note: "Supsis'te cevaplayamazsınız, diğer cihazlarınızdan cevaplayabilirsiniz",
                            v3: "not_supported",
                            v3_note: "Supsis'te cevaplayamazsınız, diğer cihazlarınızdan cevaplayabilirsiniz",
                            waba: "partial_supported",
                            waba_note: "WABA voice to PBX açarsanız Supsis'te çağrıları alabilirsiniz",
                        },
                        {
                            name: "Arama Loglarının Alınması",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "partial_supported",
                            waba_note: "WABA voice to PBX açarsanız Supsis'te çağrıları alabilirsiniz",
                        },
                        {
                            name: "Call to PBX Yönlendirme",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "supported",
                            waba_note: "NetGSM, Twilio, Telnyx gibi sistemlere çağrı aktarılabilir",
                        },
                        {
                            name: "Supsis'ten WhatsApp Arama",
                            v2: "not_supported",
                            v3: "not_supported",
                            waba: "not_supported",
                            waba_note: "Beta olarak önümüzdeki aylarda gelecek",
                        },
                    ],
                },
                {
                    name: "Senkronizasyon",
                    icon: "sync",
                    features: [
                        {
                            name: "Diğer Cihazdan Gönderilen Mesajlar",
                            v2: "partial_supported",
                            v2_note: "Aktif chat yoksa ilk mesaj gelmez",
                            v3: "supported",
                            v3_note: "Tüm mesajlar sync olur Supsis'te",
                            waba: "not_supported",
                            waba_note: "WABA'lar zaten cihazda çalışan bir versiyon değildir",
                        },
                    ],
                },
            ],
            filteredCategories: [],
        };
    },
    mounted() {
        this.filteredCategories = this.categories;
    },
    methods: {
        getSupportClass(status) {
            return {
                supported: status === "supported",
                partial: status === "partial_supported",
                "not-supported": status === "not_supported",
            };
        },
        getSupportIcon(status) {
            switch (status) {
                case "supported":
                    return "check_circle";
                case "partial_supported":
                    return "help";
                case "not_supported":
                    return "cancel";
                default:
                    return "help";
            }
        },
        getSupportText(status) {
            switch (status) {
                case "supported":
                    return "Destekleniyor";
                case "partial_supported":
                    return "Kısmi Destek";
                case "not_supported":
                    return "Desteklenmiyor";
                default:
                    return "Bilinmiyor";
            }
        },
        filterFeatures() {
            if (!this.searchQuery.trim()) {
                this.filteredCategories = this.categories;
                return;
            }

            const query = this.searchQuery.toLowerCase();
            this.filteredCategories = this.categories
                .map((category) => {
                    const filteredFeatures = category.features.filter(
                        (feature) =>
                            feature.name.toLowerCase().includes(query) ||
                            (feature.description && feature.description.toLowerCase().includes(query)) ||
                            (feature.v2_note && feature.v2_note.toLowerCase().includes(query)) ||
                            (feature.v3_note && feature.v3_note.toLowerCase().includes(query)) ||
                            (feature.waba_note && feature.waba_note.toLowerCase().includes(query))
                    );

                    return {
                        ...category,
                        features: filteredFeatures,
                    };
                })
                .filter((category) => category.features.length > 0);
        },
    },
};
</script>

<style lang="scss" scoped>
.whatsapp-comparison {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    height: 80vh;

    .comparison-header {
        padding: 24px;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        .title {
            margin: 0;
            font-size: 24px;
            font-weight: 600;
            color: #2c3e50;
        }
    }

    .table-wrapper {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        border: 1px solid #e8eef3;
        border-radius: 8px;
        overflow: hidden;
        margin: 0 24px;
    }

    .table-header-fixed {
        position: sticky;
        top: 0;
        z-index: 10;
        background: white;
        border-bottom: 2px solid #e8eef3;
    }

    .table-body-scrollable {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .comparison-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;

        th,
        td {
            padding: 12px 16px;
            text-align: center;
            border-bottom: 1px solid #f0f0f0;
        }

        th {
            background: #f8f9fa;
            font-weight: 600;
            border-bottom: 2px solid #e8eef3;

            &.feature-column {
                text-align: left;
            }
        }

        .feature-column-width,
        .feature-column {
            width: 300px;
            min-width: 300px;
        }

        .solution-column-width,
        .solution-column {
            width: 200px;
            min-width: 200px;
        }

        .solution-header {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;

            .solution-info {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 4px;

                span:first-child {
                    font-weight: 600;
                    font-size: 14px;
                }

                .solution-subtitle {
                    font-size: 12px;
                    color: #666;
                    font-weight: normal;
                }
            }
        }

        .category-header {
            background: #f5f8fb;

            td {
                padding: 16px;
                border-bottom: 2px solid #dbe1e8;
            }

            .category-title {
                display: flex;
                align-items: center;
                gap: 8px;
                font-weight: 600;
                font-size: 16px;
                color: #2c3e50;

                .material-icons {
                    font-size: 20px;
                    color: #4a6cf7;
                }
            }
        }

        .feature-row {
            &:hover {
                background: #fafbfc;
            }

            .feature-name {
                font-weight: 500;
                color: #2c3e50;
                position: relative;
                text-align: left;

                .info-icon {
                    font-size: 16px;
                    color: #666;
                    margin-left: 8px;
                    cursor: help;
                }
            }

            .support-cell {
                .support-status {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 8px;

                    .support-icon {
                        font-size: 28px;
                    }

                    &.supported {
                        .support-icon {
                            color: #52c41a;
                        }
                    }

                    &.partial {
                        .support-icon {
                            color: #fa8c16;
                        }
                    }

                    &.not-supported {
                        .support-icon {
                            color: #ff4d4f;
                        }
                    }
                }

                .support-note {
                    font-size: 12px;
                    color: #666;
                    line-height: 1.4;
                    padding: 6px 8px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border-left: 3px solid #ddd;
                    text-align: left;
                    margin: 0 8px;
                }
            }
        }
    }

    .comparison-legend {
        position: sticky;
        bottom: 0;
        z-index: 10;
        padding: 16px 24px;
        background: #f8f9fa;
        display: flex;
        gap: 24px;
        border-top: 1px solid #e8eef3;
        margin-top: auto;

        .legend-item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;

            .material-icons {
                font-size: 20px;

                &.supported {
                    color: #52c41a;
                }

                &.partial {
                    color: #fa8c16;
                }

                &.not-supported {
                    color: #ff4d4f;
                }
            }
        }
    }
    .img {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        overflow: hidden;
        position: relative;

        &.webhooks {
            background: #7159c2;
        }

        &.postacell,
        &.ticimax,
        &.holidayplus {
            width: 200px;
        }

        &.ideasoft {
            width: 200px;
        }

        &.supsis {
            background: #e8eef3;
        }

        &.openai {
            background: #a2cbed;
        }

        &.whatsapp {
            background: #58ca64;
        }

        &.linkedin {
            background: #e2e5ff;
        }

        &.retell {
            background: #673ab7;

            .material-icons {
                color: #fff;
            }
        }

        &.webphone {
            background: #f5f5f5;

            .material-icons {
                font-size: 40px;
            }
        }

        &.telnyx {
            background: #f0f8ff;

            img {
                object-fit: contain;
            }
        }

        &.netgsm {
            background: #f5f5f5;

            img {
                object-fit: contain;
            }
        }

        &.instagram {
            background: radial-gradient(
                circle at 30% 107%,
                #fdf497 0%,
                #fdf497 5%,
                #fd5949 45%,
                #d6249f 60%,
                #285aeb 90%
            );
        }

        &.telegram {
            background: #29b6f6;
        }

        &.twitter {
            background: #3ecdfb;
        }

        &.slack {
            background: #634360;
        }

        &.mail {
            justify-content: unset !important;

            svg {
                width: 100%;
                height: 100%;
            }
        }

        &.facebook,
        &.skype,
        &.shopify {
            background: #ffffff;
        }

        &.teamgram svg {
            width: 100%;
        }

        &.retell {
            background: #673ab7;
        }

        svg {
            width: 65%;
        }

        &:after {
            background: #fff;
            bottom: 0;
            content: "";
            height: 100%;
            left: -10%;
            opacity: 0.3;
            position: absolute;
            top: 0;
            transform: rotate(45deg) translate(-20%, 150%);
            width: 160%;
        }
    }
}
</style>
